export enum WorkpackLevel {
  WORKPACKS = 'workpacks',
  ITEMS = 'workpackItems',
  PARTS = 'workpackParts',
  VIEWS = 'workpackViews',
}

export enum WorkpackReload {
  OPTIMISTIC = 'optimistic',
  SERVER = 'server',
}

export enum ClientExtraEquipmentText {
  NONE = 'none',
  COATING_BREAKDOWN = 'coating breakdown',
  DEGREE_OF_RUSTING = 'degree of rusting',
}

export enum Orientation {
  UP = 'up',
  DOWN = 'down',
  LEFT = 'left',
  RIGHT = 'right',
  BACK = 'back',
  CENTER = 'center',
}
export enum SpecialLabels {
  unlabelled = 'unlabelled',
  deleted = 'delete',
}

export enum LabelTaggingMode {
  NONE = 'none',
  PART = 'part',
  ANNOTATION = 'annotation',
}

export enum HighlightStyle {
  TYPE = 'type',
  PART = 'part',
  ASSEMBLY = 'assembly',
}
